import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({
	reference: yup.string().required('Reference is a required field'),
});

export default function Reference(props) {
	const { open, onClose, data } = props;

	const isEdit = !!data;

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			name: data?.reference || '',
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const onSubmit = () => {
		handleClose();
	};

	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[380px]'>
				<span className='text-2xl modal-title'>{isEdit ? `Edit (${data.reference})` : 'Legg til ny Kode'}</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					<BaseInputValidation control={control} name='name' label='Code Name' errors={errors} required />

					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							{isEdit ? 'Oppdater' : 'Legg til'}
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
